(() => {

  Controller.$inject = ['AppUtils', 'EdgeDeviceService', 'Customer', 'EdgeAgent'];
  angular
    .module('app')
    .component('edgeAgentAssetModal', {
      template:'<div ng-class="{transparent: ctrl.loading}"><div class="modal-header"><button type="button" class="close" ng-click="ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span>{{ctrl.edgeAgent.name}} |</span> <span translate>entities.asset.modelNamePl</span></div><div class="modal-body"><div class="form-group"><label translate>entities.project.modelNamePl</label><ui-select ng-model="ctrl.projectId" theme="select2" ng-change="ctrl.filterParents()"><ui-select-match placeholder="{{\'general._select.an\' | translate}} {{\'entities.project.modelName\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="project.id as project in ctrl.projects | filter: $select.search"><div>{{project.name}}</div></ui-select-choices></ui-select></div><div class="form-group"><label translate>entities.asset.modelNamePl</label><ui-tree-select ng-model="ctrl.selectedParent" ng-disabled="!ctrl.projectId" ng-change="ctrl.selectParent()" placeholder="{{::\'general._select.an\' | translate}} {{::\'entities.asset.modelName\' | translate}}" data="ctrl.filteredParents" label-field="\'name\'" parent-field="\'assetId\'"></ui-tree-select></div><div class="form-group clearfix"><multi-select-dropdown items="ctrl.filteredAssets" disabled="ctrl.loadingAssets" selected-items="ctrl.selectedAssets"></multi-select-dropdown></div><div class="clearfix"><button class="btn btn-default pull-right border-default" ng-click="ctrl.addAssets()" ng-disabled="!ctrl.selectedAssets.length || ctrl.loadingAssets"><i class="fas fa-fw" ng-class="ctrl.loadingAssets? \'fa-spinner fa-spin\': \'fa-plus\'"></i> <span translate>buttons.add</span></button></div><hr><edge-agent-asset-table agent-assets="ctrl.edgeAgent.assets" assets="ctrl.assets"></edge-agent-asset-table></div><div class="modal-footer"><button class="btn btn-default js-btn-step pull-left" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-click="ctrl.applyChanges()" translate>buttons.save</button></div></div><spinner css-class="\'small\'" show-logo="true" show="ctrl.loading"></spinner>',
      controller: Controller,
      controllerAs: 'ctrl',
      bindings: {
        resolve: '<',
        modalInstance: '<',
      },
    });

  function Controller(utils, EdgeDeviceService, Customer, EdgeAgent) {
    const vm = this;

    vm.$onInit = function () {
      vm.device = vm.resolve.device;
      vm.projects = vm.resolve.projects;
      vm.assets = vm.resolve.assets;
      vm.assetsArray = angular.copy(Object.values(vm.assets));
      vm.edgeAgent = angular.copy(vm.resolve.edgeAgent);
      vm.edgeAgentAssets = angular.copy(vm.edgeAgent.assets || []);

      if (vm.projects.length === 1) {
        vm.projectId = vm.projects[0].id;
        filterParents();
      }

      vm.selectParent = selectParent;
      vm.filterParents = filterParents;
      vm.addAssets = addAssets;
      vm.applyChanges = applyChanges;
    };

    function filterParents() {
      vm.selectedParent = null;
      vm.selectedAssets = [];
      const filteredParents = vm.assetsArray.filter(current => current.projectId === vm.projectId);
      const map = filteredParents.reduce((map, asset) => {
        map[asset.id] = map[asset.id] || {children: []};
        map[asset.assetId] = map[asset.assetId] || {children: []};

        map[asset.id].asset = asset;
        map[asset.assetId].children.push(asset);
        return map;
      }, {});


      vm.filteredParents = Object.values(map).reduce((array, current) => {
        if (current.asset && current.children.length) {
          array.push(current.asset);
        }
        return array;
      }, []);
    }

    function selectParent() {
      vm.selectedAssets = [];
      vm.filteredAssets = vm.assetsArray.filter(current => current.id === vm.selectedParent || current.assetId === vm.selectedParent);
    }

    function addAssets() {
      if (!vm.selectedAssets.length) {
        return;
      }

      vm.edgeAgent.assets = vm.edgeAgent.assets || [];

      let assets = vm.selectedAssets.map(current => current.id);
      assets = assets.filter(current => !vm.edgeAgent.assets.find(a => a.id === current));

      if (assets.length) {
        vm.loadingAssets = true;
        Customer
          .prototype$__get__assets({
            id: vm.device.customerId,
            filter: {
              where: {id: {inq: assets}},
              fields: ['id', 'name', '_config', 'projectId', 'assetId'],
              include: {
                relation: 'asset',
                scope: {fields: ['id', 'name', '_config']},
              },
            },
          })
          .$promise
          .then(assets => {
            vm.loadingAssets = false;
            Array.prototype.push.apply(vm.edgeAgent.assets, assets);
          })
          .catch(err => {
            vm.loadingAssets = false;
            console.log(err);
          });
      }
    }

    function applyChanges() {
      const oldAssetIds = vm.edgeAgentAssets.map(current => current.id);
      const newAssetsIds = vm.edgeAgent.assets.map(current => current.id);

      const toLink = newAssetsIds.filter(current => !oldAssetIds.includes(current));
      const toUnlink = oldAssetIds.filter(current => !newAssetsIds.includes(current));

      vm.loading = true;
      return toggleEdgeAgentAssetsRel(vm.edgeAgent.id, toLink, 'link')
        .then(() => {
          return toggleEdgeAgentAssetsRel(vm.edgeAgent.id, toUnlink, 'unlink');
        })
        .then(() => {
          return EdgeDeviceService.loadEdgeAgents(vm.device.customerId, vm.device.id);
        })
        .then(function (agents) {
          vm.loading = false;
          vm.modalInstance.close(agents);
        });
    }

    function toggleEdgeAgentAssetsRel(edgeAgentId, assetIds, type) {
      type = utils.capitalize(type);
      if (!assetIds || !assetIds.length) {
        return utils.Promise.resolve();
      }

      const chunks = utils.arrayToChunks(assetIds, 50);
      const promises = chunks.map(chunk => {
        return {
          function: EdgeAgent[`prototype$__bulk${type}__assets`],
          args: [{
            id: edgeAgentId,
            where: {id: {inq: chunk}},
          }, {}],
        };
      });
      return utils.inOrderPromises(promises);
    }
  }
})();